import * as React from "react";
import { NuorderFull } from "components/icons/nuorder-full";
import theme from "styles/theme";
import { DATATEST } from "constants/integration";
import { merge, $ } from "glamor";

export const FormTitleLogo = ({ model, siteLogo }: { model?: any; siteLogo?: any }) => {
    const styles = merge(
        {
            textAlign: "center",
            margin: "16px 0 16px",
        },
        $("img", {
            maxWidth: "100%",
        })
    );

    const muiStyles = {
        width: "unset",
        maxWidth: "100%",
        height: "unset",
    };

    const logoToDisplay = (() => {
        if (siteLogo) {
            return "siteLogo";
        }
        if (model) {
            return "model";
        }
        return "nuOrder";
    })();

    return (
        <h1 {...styles}>
            {logoToDisplay === "siteLogo" && (
                <img data-test={DATATEST.LOGIN.SITE_LOGIN_IMG} alt="NuORDER" src={siteLogo} />
            )}
            {logoToDisplay === "model" && (
                <img
                    data-test={DATATEST.LOGIN.BRANDED_LOGIN_IMG}
                    alt={model.brand_name}
                    src={"https://cdn1.nuorder.com/branded_login_logo/" + model.logo + ".png"}
                />
            )}

            {logoToDisplay === "nuOrder" && <NuorderFull color={theme.palette.darkerGrey} style={muiStyles} />}
        </h1>
    );
};
